import React, { useState } from 'react';
import getCancelToken from '../../util/axios';
import ValidationTypes from '../../util/validationTypes';
import axios from 'axios';
import useLoadingForm from '../../hooks/loadingFormHook';
import useLoading from '../../hooks/loadingHook';
import Dropdown from '../dropdown/Dropdown';
import LoadButton from './LoadButton';
import FeatureSwitch from './FeatureSwitch';

import '../../styles/dashboard/DashboardAutoRelist.css';

export default function DashboardAutoRelist() {
    const [cancelBumpToken, setCancelBumpToken] = useState(getCancelToken());
    const [featureEnabled, setFeaturedEnabled] = useState(false);

    const days = [
        "1 day", 
        "2 days", 
        "3 days",
        "4 days",
        "5 days", 
        "6 days",
        "7 days"
    ];

    const saveHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/500");
    };


    const autoRelistFormRules = {
        relistAfter: [ValidationTypes.requiredString]
    };

    const { setFormData, loading, loaded, setLoaded, handleSubmit, errorMapping } = useLoadingForm({
        relistAfter: ''
    }, saveHandler, null, null, autoRelistFormRules);

    const bumpAllHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/500", {
            cancelToken: cancelBumpToken.token
        })
    }
    const { loading: bumpLoading, loaded: bumpLoaded, handleLoad } = useLoading(bumpAllHandler);

    const handleDropdownChange = (item) => {
        if (loaded) {
            setLoaded(false);
        }

        setFormData({relistAfter: item});
    }

    const handleFeatureSwitch = () => {
        setFeaturedEnabled(!featureEnabled);
    }

    return (
        <div className="DashboardAutoRelist">
            <div className="header relative">
                <h1>Auto Relist Products</h1>
                <p>Bump your products automatically after a
                 certain time period or all at once right now!</p>
                <FeatureSwitch enabled={featureEnabled} handleClick={handleFeatureSwitch}/>
            </div>
            <div className="content-split">
                <form 
                className="formDashboard auto-relist-section"
                onSubmit={handleSubmit}>
                    <p className="label">Relist all items after</p>
                    <Dropdown 
                    items={days}
                    handleChange={handleDropdownChange}
                    errorText={errorMapping.relistAfter}
                    loading={loading} />
                    <LoadButton 
                    loading={loading}
                    loaded={loaded} 
                    defaultText="Save!"
                    loadingText="Saving"
                    loadedText="Saved"
                    classes="black"
                    theme="white" />
                </form>
                <div className="manual-relist-section">
                    <LoadButton 
                    loading={bumpLoading}
                    loaded={bumpLoaded}
                    defaultText="Bump All Right Now!"
                    loadingText="Bumping All"
                    loadedText="Bumped All"
                    classes="bg-yellow"
                    theme="black" 
                    handleClick={() => {
                        if (!bumpLoaded) {
                            handleLoad();
                        }
                    }} /> 
                    <button 
                    className={bumpLoading ? "secondary-button" : "disabled-button"}
                    onClick={(e) => {
                        if (bumpLoading) {
                            cancelBumpToken.cancel();
                            setCancelBumpToken(getCancelToken());
                        }
                    }}>Stop Relisting</button>
                </div>
            </div>
        </div>
    )
}